import React from "react";
import { Button } from "../../components";
import { loginModal, registerModal } from "../../state/action";
import { useDispatch, useSelector } from "react-redux";

import Logo from "../../assets/SC.png";

const AuthHeader = () => {
  const dispatch = useDispatch();
  const { isDarkMode } = useSelector(({ common }) => common);

  return (
    <>
      <div className="display flex flex-row mx-auto px-4 lg:px-12 py-4 lg:py-4 justify-between bg-white header">
        <div className="hidden lg:block">
          <div className={`${!isDarkMode ? "block" : "hidden"}`}>
            <img src={Logo} />
          </div>
          <div className={`${isDarkMode ? "block" : "hidden"}`}>
            <h4 className="font-bold text-2xl header-dark">SportsCliq</h4>
          </div>
        </div>
        <div className="flex justify-between w-1/3 navigation auth-nav">
         
        </div>
        <div className="flex justify-around items-center w-1/4 lg:w-1/4">
          <div className="flex">
            <div className="hidden lg:block mr-5">
              <Button
                type="primary"
                className="primary-color button-secondary w-full"
                title="Sign Up"
                onClick={() => dispatch(registerModal())}
                style={{
                  borderRadius: "30px",
                  padding: "0 25px",
                }}
              />
            </div>
            <div className="hidden lg:block">
              <Button
                type="primary"
                className="primary- button-transparent"
                title="Sign In"
                onClick={() => dispatch(loginModal())}
                style={{
                  borderRadius: "30px",
                  padding: "0 25px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthHeader;
